import React from "react";
import { YahooContent } from "../yahoo/YahooContent";
import Logger from "../commons/Logger";

export function AdContent({ page }: { page: string }) {
  // Since this is a temporary fix, we will log the page parameter.
  // This prevents us from removing the page prop in a whole lot of places, making this temp fix bigger than it needs to be
  Logger.debug("AdContent page parameter (deprecated):", page);
  // Yahoo content is now the default for all traffic including missing AdSense params
  // AdSensePage no longer routes to NoAdsPage; all traffic flows through layouts
  // TODO: Review this implementation after RSOC migration is complete

  return <YahooContent />;
}
